import { useEffect } from 'react';
import { X } from 'lucide-react';
import { useAppSelector, useAppDispatch } from '@/store';
import { uiActions } from '@/store/slices/uiSlice';
import { cn } from '@/utils/helpers';

export function ToastContainer() {
  const toasts = useAppSelector((state) => state.ui.toasts);
  const dispatch = useAppDispatch();

  if (toasts.length === 0) return null;

  const latestToast = toasts[toasts.length - 1];

  return (
    <div className="fixed right-4 top-20 z-50 flex max-w-[calc(100vw-2rem)] flex-col gap-2" aria-live="polite">
      <ToastItem
        key={latestToast.id}
        id={latestToast.id}
        message={latestToast.message}
        type={latestToast.type}
        onClose={() => dispatch(uiActions.removeToast(latestToast.id))}
      />
    </div>
  );
}

interface ToastItemProps {
  id: string;
  message: string;
  type: 'success' | 'error' | 'warning' | 'info';
  onClose: () => void;
}

const TOAST_STYLES = {
  success: 'border-2 border-accent bg-white text-text-primary font-semibold',
  error: 'border-2 border-error bg-white text-text-primary font-semibold',
  warning: 'border-2 border-accent bg-white text-text-primary font-semibold',
  info: 'border-2 border-accent bg-white text-text-primary font-semibold',
};

function ToastItem({ id, message, type, onClose }: ToastItemProps) {
  useEffect(() => {
    const timer = setTimeout(onClose, 4000);
    return () => clearTimeout(timer);
  }, [id, onClose]);

  return (
    <div
      className={cn(
        'flex min-w-72 max-w-sm items-center gap-3 rounded-[var(--radius-md)] border px-4 py-3 shadow-md',
        TOAST_STYLES[type],
      )}
      role="alert"
    >
      <p className="text-sm font-medium">{message}</p>
      <button
        onClick={onClose}
        className="ml-auto shrink-0 opacity-60 hover:opacity-100"
        aria-label="Close notification"
      >
        <X className="h-4 w-4" />
      </button>
    </div>
  );
}


